<template>
  <transition>
    <div class="container-mask" v-show="visible" @touchmove.prevent ref="loginMain">
      <div class="container" ref="areaLogin">
        <i class="btn-close" @click="closePop"></i>
        <div class="mg-title">{{ title }}</div>
        <div class="mg-form">
          <div class="mg-item">
            <div class="mg-wrapper" :class="{focus: focus.mobile, error: errorTip.mobile}">
              <input
                type="tel"
                placeholder="请输入手机号"
                v-model="form.mobile"
                @input="limitMobile"
                @blur="blurRule('mobile')"
                @focus="addFocus('mobile')">
              <i class="close" @click="emptyInput('mobile')"/>
            </div>
            <p class="tips" v-show="errorTip.mobile">{{ errorTip.mobile }}</p>
          </div>
          <div class="mg-item" v-show="showImg">
            <div class="mg-wrapper mg-code" :class="{focus: focus.picVerifyCode, error: errorTip.picVerifyCode}">
              <input
                type="text"
                maxlength="6"
                placeholder="请输入图片验证码"
                v-model="form.picVerifyCode"
                @blur="blurRule('picVerifyCode')"
                @focus="addFocus('picVerifyCode')">
              <i class="close" @click="emptyInput('picVerifyCode')"/>
              <span class="mg-btn mg-img">
                <img :src="imgurl" @click="showImgVerify">
              </span>
            </div>
            <p class="tips" v-show="errorTip.picVerifyCode">{{ errorTip.picVerifyCode }}</p>
          </div>
          <div class="mg-item">
            <div class="mg-wrapper mg-code" :class="{focus: focus.mobileVerifyCode, error: errorTip.mobileVerifyCode}">
              <input
                type="tel"
                maxlength="6"
                placeholder="请输入验证码"
                v-model="form.mobileVerifyCode"
                @blur="blurRule('mobileVerifyCode')"
                @focus="addFocus('mobileVerifyCode')">
              <i class="close" @click="emptyInput('mobileVerifyCode')"/>
              <span class="mg-btn" v-show="!smsIntervalFlag" @click="getSmsCode">{{ btnText }}</span>
              <span class="mg-btn mg-interval" v-show="smsIntervalFlag">{{ smsInterval }}s</span>
            </div>
            <p class="tips" v-show="errorTip.mobileVerifyCode">{{ errorTip.mobileVerifyCode }}</p>
          </div>
          <button class="mg-submit" :class="{disabled: !isDisabled}" @click="login">登录</button>
        </div>
        <div class="bottom-info">新用户初次登陆将自动注册，<br>注册成功即视为已阅读并同意<a href="/login/protocol">《用户使用条款协议和隐私说明》</a>及<a href="https://h5.mgzf.com/minisite/renterApp/privacyPolicy.html" target="_blank">《蘑菇租房隐私政策》</a></div>
      </div>
    </div>
  </transition>
</template>

<script>
  import cookieUtil from '../../library/cookieUtil'
  import userAgentHelper from '../../library/userAgentHelper'
  import initStyle from "../../mixins/initStyle";


  const TIME_COUNT = 60;
  export default {
    data() {
      return {
        visible: false,
        closed: false,
        title: '',
        inputTimer: Object,
        contactPhone: '',
        focus: {
          mobile: false,
          picVerifyCode: false,
          mobileVerifyCode: false,
        },
        errorTip: {
          mobile: '',
          picVerifyCode: '',
          mobileVerifyCode: '',
        },
        form: {
          mobile: '',
          mobileVerifyCode: '',
          picVerifyCode: '',
          channel: userAgentHelper.channel,
          bizType: 606,
          picVerifyCodeToken: cookieUtil.getCookie('uuid')
        },
        btnText: '短信验证码',
        smsIntervalFlag: false,
        smsInterval: 60,
        timer: null,
        showImg: true,
        imgurl: '',
        logoUrl: '',
        store: null
      };
    },
    mixins: [initStyle],
    computed: {
      isDisabled() {
        return this.form.mobile.length > 0 && this.form.mobileVerifyCode.length > 0 && (this.showImg ? this.form.picVerifyCode : true);
      }
    },
    watch: {
      closed(newVal) {
        if (newVal) {
          this.visible = false;
          this.destroyElement();
        }
      }
    },
    mounted() {
      this.form.mobile = this.contactPhone || '';
      this.showImgVerify()
    },
    methods: {
      closePop() {
        this.closed = true;
      },
      destroyElement() {
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
      },
      addFocus(type) {
        this.focus[type] = true;
        clearTimeout(this.inputTimer);
      },
      blurRule(type) {
        this.focus[type] = false;
        this.errorTip[type] = '';
        this.inputTimer = setTimeout(() => {
          document.body.scrollTop = 0;
        }, 300);
        switch (type) {
          case 'mobile':
            this.validateMobile();
            break;
          case 'picVerifyCode':
            this.validatePicVerify();
            break;
          case 'verifyCode':
            this.validateVerifyCode();
            break;
        }
      },
      hideAllError() {
        Object.keys(this.errorTip).forEach((item) => {
          this.errorTip[item] = '';
        });
      },
      emptyInput(type) {
        this.form[type] = '';
      },
      limitMobile() {
        let mobile = this.form.mobile.replace(/[^\d]+/g, '');
        this.form.mobile = mobile.substring(0, 11);
      },
      validateMobile() {
        if (this.form.mobile.length === 0) {
          this.errorTip.mobile = '手机号不能为空';
          return false;
        } else if (!/^1[0-9]{10}$/.test(this.form.mobile)) {
          this.errorTip.mobile = '请输入正确手机号码';
          return false;
        }
        return true;
      },
      validateVerifyCode() {
        if (this.form.mobileVerifyCode.length === 0) {
          this.errorTip.mobileVerifyCode = '验证码不能为空';
          return false;
        }
        return true;
      },
      validatePicVerify() {
        if (this.form.picVerifyCode.length === 0) {
          this.errorTip.picVerifyCode = '图片验证码不能为空';
          return false;
        }
        return true;
      },
      countDown() {
        if (!this.timer) {
          this.smsInterval = TIME_COUNT;
          this.smsIntervalFlag = true;
          this.timer = setInterval(() => {
            if (this.smsInterval > 0 && this.smsInterval <= TIME_COUNT) {
              this.smsInterval--;
            } else {
              clearInterval(this.timer);
              this.timer = null;
              this.btnText = "重新获取";
              this.smsInterval = 60;
              this.smsIntervalFlag = false;
            }
          }, 1000);
        }
      },
      showImgVerify() {
        this.showImg = true;
        this.imgurl = this.$api.authorize.getImgVerifyCode(this.form.picVerifyCodeToken, this.form.channel);
      },
      getSmsCode() {
        this.hideAllError();
        if (!this.validateMobile()) {
          return false;
        }
        if (this.showImg && !this.validatePicVerify()) {
          return false
        }
        this.$api.authorize.sendVerifyCode(this.form).then(response => {
          let res = response.data;
          if (res.code === '10000') {
            this.countDown();
            this.$tips('验证码已发送');
          } else if (res.code === '10007') {
            this.showImgVerify();
            this.$tips(res.message);
          } else {
            this.$tips(res.message);
          }
        }).catch();
      },
      login() {
        this.hideAllError();
        if (!this.isDisabled) {
          return false;
        }
        if (!this.validateMobile()) {
          return false;
        }
        if (this.showImg && !this.validatePicVerify) {
          return false
        }
        if (!this.validateVerifyCode()) {
          return false;
        }
        this.$api.authorize.loginByVerifyCode(this.form).then(response => {
          let res = response.data;
          if (res.code === '10000') {
            let content = res.content;
            var auth = {
              userId: content.renterId,
              mobile: content.mobile,
              token: content.token,
              userName: content.userName,
              email: content.email,
              userLogo: content.userLogo,
              regId: content.regId,
              loginDevicePIafForm: content.loginDevicePIafForm,
              isConvertRenter: content.isConvertRenter,
              turnOffFlag: content.turnOffFlag,
              idCardState: content.idCardState,
              payPwdState: content.payPwdState,
              pwdState: content.pwdState
            };
            this.store.dispatch("setAuth", auth);
            this.closed = true;
            this.loginSuccess();
          } else if (res.code === '10007') {
            this.showImgVerify();
            this.$tips(res.message);
          } else if (res.code === '10009') {
            this.errorTip.mobileVerifyCode = '验证码错误,请重新输入';
          } else {
            this.$tips(res.message);
          }
        }).catch();
      },
      loginSuccess(){
        if(typeof this.onSuccess === 'function'){
          this.onSuccess(this);
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .container-mask {
    display: flex;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background: rgba(0, 0, 0, .7);
  }

  .container {
    position: absolute;
    left: 50%;
    z-index: 1000;
    margin-left: ptr(-140);
    width: ptr(280);
    padding: ptr(15);
    overflow: hidden;
    background: #fff;
    box-sizing: border-box;
    border-radius: ptr(10);
  }

  .btn-close {
    display: inline-block;
    float: right;
    margin-right: ptr(3);
    width: 0.15em;
    height: 1.3em;
    background: #BFBFBF;
    transform: rotate(45deg);
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 0.15em;
      height: 1.3em;
      background: #BFBFBF;
      transform: rotate(270deg);
    }
  }

  .mg-title {
    margin-top: ptr(10);
    width: 100%;
    text-align: center;
  }

  .mg-form {
    width: 12.8rem;
    margin: ptr(20) auto 0;
    overflow: hidden;
    .mg-item {
      width: 12.8rem;
      height: 2.9rem;
      overflow: hidden;
      .mg-wrapper {
        position: relative;
        width: ptr(250);
        height: ptr(40);
        padding-top: ptr(8);
        border: .0427rem solid #dcdcdc;
        border-radius: ptr(2);
        &.mg-code {
          input {
            float: left;
            width: ptr(150);
          }
          .mg-img {
            border-left: none;
          }
          .close {
            right: 4.4rem;
          }
          img {
            width: 80%;
            margin-top: -.2rem;
          }
        }
        &.focus {
          border-color: #f65000;
        }
        .mg-btn {
          float: left;
          width: 3.84rem;
          height: .9387rem;
          line-height: .9387rem;
          color: #f65000;
          font-size: .5973rem;
          border-left: 1px solid #dcdcdc;
          border-radius: 0;
          text-align: center;
          &.mg-interval {
            color: #999;
          }
        }
        .close {
          display: none;
          position: absolute;
          right: .4267rem;
          top: .42rem;
          z-index: 55;
          width: .7533rem;
          height: .7533rem;
          border-radius: .8533rem;
          background: rgba(0, 0, 0, .5);
          &:before, &:after {
            position: absolute;
            left: .34rem;
            top: 0.13rem;
            z-index: 65;
            content: "";
            display: block;
            width: .0427rem;
            height: .512rem;
            background: #fff;
            transform: rotate(-45deg);
          }
          &:after {
            transform: rotate(45deg);
          }
        }
        &.focus .close {
          display: block;
        }
      }
      input {
        padding: .1493rem 0 .1493rem .256rem;
        width: ptr(250);
        height: .9387rem;
        font-size: .64rem;
        border: 0;
        box-sizing: border-box;
        color: #333;
      }
      .tips {
        font-size: .512rem;
        margin-top: 5px;
        color: #ff3434;
        padding-left: .256rem;
      }
    }
    .mg-submit {
      outline: none;
      width: ptr(250);
      height: ptr(40);
      color: #fff;
      font-size: .6827rem;
      background: #f65000;
      border: 0;
      border-radius: ptr(3);
      letter-spacing: 5px;
      cursor: pointer;
      &.disabled {
        color: #999999;
        background: #ddd;
      }
    }
  }

  .bottom-info {
    margin-top: ptr(12);
    width: 100%;
    text-align: center;
    font-size: ptr(12);
    color: #bababa;
    a {
      display: inline-block;
      color: rgba(15, 162, 255, 0.8);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue